import styled, { css } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

interface StyledCartPriceProps {
    $size?: number;
}

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    ${styledTypography.truncate};
    letter-spacing: -0.02em;
`;

export const StyledCartPrice = styled.div<StyledCartPriceProps>`
    display: grid;
    justify-items: end;
    gap: 0.1em;
    font-size: ${({ $size }) => $size}px;
`;

export const Item = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    gap: 0.1em;
`;

export const NativePrice = styled.p`
    ${typographyBase};
    font-size: 1em;
    font-weight: 700;
`;

export const UsdPrice = styled.p`
    ${typographyBase};
    font-size: 0.8em;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.5);
`;
